import { useAuth } from "@airborne/react-admin";
import React from "react";
import OwnerSelection from "./OwnerSelection";

export const NavBarOwnerSelection = props => {
  const { user } = useAuth();

  return user?.isOwnerCodeEditable ? <OwnerSelection /> : <></>;
};

export default NavBarOwnerSelection;
